import React from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import "flatpickr/dist/themes/material_green.css";
import { ToastContainer } from "react-toastify";
import Detail from "./Detail";

const MrStaffIndex = () => {

  //meta title
  document.title = "Ажилтан";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Үндсэн бүртгэл" breadcrumbItem="Ажилтан" />
          <Detail />
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}


export default MrStaffIndex;